export const siteSettings = {
  name: "FX Horizon",
  link: "https://fxhorizonpro.com/",
  email: "support@fxhorizonpro.com/",
  appLink: "https://app.fxhorizonpro.com/",
};
